<script setup>
import { provide } from "vue";
import { useField } from "vee-validate";
import { FORM_ITEM_INJECTION_KEY } from "./injectionKeys";

const props = defineProps({
  name: { type: String, required: true },
});

const { componentField, value, errorMessage, handleChange, handleBlur } =
  useField(() => props.name);

const id = `form-${props.name}`;

provide(FORM_ITEM_INJECTION_KEY, { id, name: props.name });

defineSlots();
</script>

<template>
  <slot
    :componentField="componentField"
    :value="value"
    :errorMessage="errorMessage"
    :handleChange="handleChange"
    :handleBlur="handleBlur"
  />
</template>
